import React from 'react';
import { Chip } from '@mui/material';
import {
  Psychology as OlimpicoIcon,
  EmojiEvents as HeroeIcon,
  Pets as DragonIcon,
  Shield as CaballeroIcon,
  Whatshot as DesafianteIcon,
  Security as DefensorIcon,
  AccountBalance as FaraonIcon,
  School as SacerdoteIcon,
  AutoAwesome as FaerieIcon,
  DarkMode as SombraIcon,
  AccountTree as TitanIcon,
  AllInclusive as EternoIcon
} from '@mui/icons-material';

export const RAZA_ICONS = {
  Olimpico: OlimpicoIcon,
  Heroe: HeroeIcon,
  Dragon: DragonIcon,
  Caballero: CaballeroIcon,
  Desafiante: DesafianteIcon,
  Defensor: DefensorIcon,
  Faraon: FaraonIcon,
  Sacerdote: SacerdoteIcon,
  Faerie: FaerieIcon,
  Sombra: SombraIcon,
  Titan: TitanIcon,
  Eterno: EternoIcon
};

const RaceChip = ({ race, size = 'small', variant = 'outlined', sx = {} }) => {
  const RazaIcon = RAZA_ICONS[race] || null;
  
  return (
    <Chip
      size={size}
      label={race}
      icon={RazaIcon ? <RazaIcon sx={{ fontSize: size === 'small' ? '0.8rem !important' : '1rem !important' }} /> : null}
      variant={variant}
      sx={{ 
        borderRadius: 1,
        height: size === 'small' ? 18 : 24,
        '& .MuiChip-label': { 
          fontSize: size === 'small' ? '0.75rem' : '0.85rem',
          fontWeight: 'medium',
          px: size === 'small' ? 0.8 : 1,
          py: size === 'small' ? 0.1 : 0.2
        },
        ...sx
      }}
    />
  );
};

export default RaceChip; 